import Vendor from "./Vendor";
import Campaign from "./Campaign";
import { Grid, Box, Button } from "@mui/material";
import Brand from "./Brand";
import GetCookieByName from "../../hooks/GetCookie";
import jwtDecode from "jwt-decode";

export default function CategoryCards({
  updateLatestCampaign,
  totalCampaign,
  totalVendor,
  totalBrand,
}) {
  const token = JSON.parse(GetCookieByName("auth"))["token"];
  const decoded = jwtDecode(token);

  return (
    <Box>
      <Grid container spacing={2}>
        <Campaign
          updateLatestCampaign={updateLatestCampaign}
          totalCampaign={totalCampaign}
          isSuperUser={decoded.isSuperUser}
        />

        <Vendor
          totalVendor={totalVendor}
        />

        <Brand
          totalBrand={totalBrand}
          isSuperUser={decoded.isSuperUser}
        />
      </Grid>
    </Box>
  );
}
